import {register} from "./register";
import {ExcalidrawElement, ExcalidrawTextElement} from "../element/types";
import {AppClassProperties, AppState} from "../types";
import {ToolButton} from "../components/ToolButton";
import {t} from "../i18n";
import {getShortcutKey} from "../utils";
import {isSomeElementSelected} from "../scene";
import {getNonDeletedElements, isTextElement} from "../element";
import {imgPathPerfix, isNoteElement, isStringNullOrEmpty} from "../../../../src/utils";
import {Input} from "antd";
import {getFormValue} from "./actionProperties";
import {getBoundTextElement} from "../element/textElement";
import {DEFAULT_FONT_FAMILY} from "../constants";
import {newElementWith} from "../element/mutateElement";
import {KEYS} from "../keys";
import {isFreeDrawElement, isMindmapElement, isProjectLinkElement, isStickyNotesElement} from "../element/typeChecks";
import {useState} from "react";
import {updateBoundElements} from "../element/binding";
import {postMessage} from "../../../../src/common/event";
import {EVENT_UPDATE_ELEMENT_BOUND} from "../../../../src/Const";

let mInputValue = 0,mInputValue1=undefined;
export const actionChangeSize = register({
    name:'changeSize',
    trackEvent:{category:'element'},
    perform:(elements, appState, formData, app) => {
        return{
            ...fixSizeElement(elements,appState,formData,app),
            commitToHistory:true
        }
    },
    contextItemLabel:"labels.changeSize",
    PanelComponent:({elements,appState,updateData,app})=> {
        const getDefaultWidth = getFormValue(
            elements,
            appState,
            (element) => {
                // if (element.extra?.tempWidth != undefined) {
                //     return (element.extra?.tempWidth);
                // }
                return Math.floor(element.width);
            },
            (element) =>
                true,
            (hasSelection) =>
                hasSelection
                    ? null
                    : 25,
        );
        const getDefaultHeight = getFormValue(
            elements,
            appState,
            (element) => {
                // if (element.extra?.tempHeight != undefined) {
                //     return (element.extra?.tempHeight);
                // }
                return Math.floor(element.height);
            },
            (element) =>
                true,
            (hasSelection) =>
                hasSelection
                    ? null
                    : 25,
        );
        const [width,setWidth] = useState(getDefaultWidth);
        const [height,setHeight] = useState(getDefaultHeight);
        const [isLockRadio,setIsLockRadio] = useState(getFormValue(
            elements,
            appState,
            (element) => {
                return element.isLockRatio;
            },
            (element) =>
                true,
            (hasSelection) =>
                false
        ));

        return(
            <fieldset>
                <div style={{display: 'flex', height: '32px', alignItems: 'center'}}>
                    <span style={{marginLeft: '-1px'}} className='text-color-666'>W</span>
                    <input
                        readOnly={
                            getFormValue(
                                elements,
                                appState,
                                (element) => {
                                    return isTextElement(element) || isFreeDrawElement(element) || isMindmapElement(element);
                                },
                                (element) =>
                                    true,
                                (hasSelection) =>
                                    false
                            )
                        }
                        style={{
                            height: '26px',
                            width: '86px',
                            border: '0px solid var(--border-color)',
                            borderRadius: '3px',
                            paddingLeft: '4px',
                            marginLeft: '4px',
                            backgroundColor: getFormValue(
                                elements,
                                appState,
                                (element) => {
                                    return isTextElement(element);
                                },
                                (element) =>
                                    true,
                                (hasSelection) =>
                                    false
                            ) ? 'transparent' : 'transparent'
                        }} prefix="W:" value={width}
                        onChange={(e) => {
                            //取当前元素
                            let ele = getSelectedElement(elements, appState);
                            if (!isNumber(e.currentTarget.value) && !isStringNullOrEmpty(e.currentTarget.value)) return;
                            var newValue: any = parseInt(e.currentTarget.value);
                            if (isNaN(newValue)) {
                                newValue = 0;
                            }
                            mInputValue = newValue;
                            if (isStringNullOrEmpty(e.currentTarget.value)) {
                                newValue = '';
                            }
                            setWidth(newValue);

                            if (isLockRadio) {
                                if (isNumber(newValue)) {
                                    if (!isNumber(height)) {
                                        setHeight(newValue)
                                    }else {
                                        setHeight(Math.round(newValue * ele.height / ele.width));
                                    }
                                }else {
                                    setHeight("")
                                }
                                // updateData({extra: {...ele.extra, tempWidth: newValue, tempHeight: mInputValue1}});
                            } else {
                                // updateData({extra: {...ele.extra, tempWidth: newValue}});
                            }
                        }}
                        onFocus={(event => {
                            mInputValue = parseInt(event.currentTarget.value)
                            let element = getSelectedElement(elements, appState);
                            mInputValue1 = element.height;

                            event.currentTarget.select();
                            app.onPointDownEvent((activeTool, pointerDownState) => {
                                // if (isNumber(width)){
                                //     let ele = getSelectedElement(elements, appState);
                                //     updateData({width: width, height: height, extra: {...ele.extra}});
                                //     app.onPointDownEvent(null);
                                // }
                            });
                        })}
                        onBlur={(event => {
                            if (isNumber(width)){
                                let ele = getSelectedElement(elements, appState);
                                updateData({width: width, height: height, extra: {...ele.extra}});
                            }
                        })}
                        onKeyDown={(event => {
                            if (event.key === KEYS.ENTER) {
                                if (!isNumber(event.currentTarget.value)) {
                                    updateData({extra: {}})
                                } else {
                                    updateData({width: width, height: height});
                                }
                                event.currentTarget.blur();
                            }
                        })}
                    />
                    <span className='text-color-666' style={{marginLeft: '6px'}}>H</span>
                    <input
                        readOnly={
                            getFormValue(
                                elements,
                                appState,
                                (element) => {
                                    return isTextElement(element) || isFreeDrawElement(element) || isMindmapElement(element);
                                },
                                (element) =>
                                    true,
                                (hasSelection) =>
                                    false
                            )
                        }
                        style={{
                            height: '26px',
                            width: '64px',
                            border: '0px solid var(--border-color)',
                            borderRadius: '3px',
                            paddingLeft: '4px',
                            marginLeft: '4px',
                            backgroundColor: getFormValue(
                                elements,
                                appState,
                                (element) => {
                                    return isTextElement(element);
                                },
                                (element) =>
                                    true,
                                (hasSelection) =>
                                    false
                            ) ? 'transparent' : 'transparent'
                        }} prefix="H:" value={height}
                        onChange={(e) => {
                            let ele = getSelectedElement(elements, appState);

                            var newValue: any = parseInt(e.currentTarget.value);
                            if (isNaN(newValue)) {
                                newValue = 0;
                            }
                            mInputValue1 = newValue;
                            if (isStringNullOrEmpty(e.currentTarget.value)) {
                                newValue = '';
                            }
                            setHeight(newValue);
                            if (isLockRadio) {
                                if (isNumber(newValue)) {
                                    if (!isNumber(height)) {
                                        setWidth(newValue);
                                    }else {
                                        setWidth(Math.round(newValue * ele.width / ele.height));
                                    }

                                }else {
                                    setWidth('')
                                }

                                // updateData({extra: {...ele.extra, tempWidth: mInputValue, tempHeight: newValue}});
                            } else {
                                // updateData({extra: {...ele.extra, tempHeight: newValue}});
                            }
                        }}
                        onFocus={(event => {
                            mInputValue1 = parseInt(event.currentTarget.value)
                            let element = getSelectedElement(elements, appState);
                            mInputValue = element.width;

                            event.currentTarget.select();
                            app.onPointDownEvent((activeTool, pointerDownState) => {
                                // if (isNumber(height)){
                                //     let ele = getSelectedElement(elements, appState);
                                //     updateData({width: width, height: height, extra: {...ele.extra}});
                                //     app.onPointDownEvent(null);
                                // }
                            });
                        })}
                        onBlur={(event => {
                            if (isNumber(height)){
                                let ele = getSelectedElement(elements, appState);
                                updateData({width: width, height: height, extra: {...ele.extra}});
                            }

                        })}
                        onKeyDown={(event => {
                            if (event.key === KEYS.ENTER) {
                                let ele = getSelectedElement(elements, appState);
                                if (!isNumber(event.currentTarget.value)) {
                                    updateData({extra: {svg: ele.svg}})
                                } else {
                                    updateData({width: width, height: height});
                                }
                                event.currentTarget.blur();
                            }
                        })}
                    />
                    <div className='hovered-round flex-center' style={{marginLeft: '1px', overflow: "hidden"}}>
                        <img style={{width: '30px', height: '30px'}} className='img-mini-small-12' src={imgPathPerfix()+(isLockRadio?'lock.png':'unlock.png')}
                             onClick={(e) => {
                                 setIsLockRadio(!isLockRadio);
                                 updateData({isLockRatio: !isLockRadio})
                             }}
                        />
                    </div>

                </div>
            </fieldset>
        )
    }
})

const getSelectedElement = (elements,appState)=>{
    for (var i=0;i<elements.length;i++) {
        var element = elements[i];
        if (appState.selectedElementIds[element.id]) {
            return element;
        }
    }
    return null;
}

const isNumber = (inputStr)=>{
    if (isStringNullOrEmpty(inputStr))return false;
    const reg = /^-?\d*(\.\d*)?$/;
    return (reg.test(inputStr));
}

const fixSizeElement = (
    elements:readonly ExcalidrawElement[],
    appState:AppState,
    formDataNew:any,
    app:AppClassProperties
) => {
    var arrayNewElements = [];

    formDataNew.updated = Date.now();

    for (var i=0;i<elements.length;i++){
        var element = elements[i];
        let formData = {...formDataNew};
        if (!formData.height){
            formData.height = element.height;
        }
        if (!formData.width){
            formData.width = element.width;
        }
        if (appState.selectedElementIds[element.id]) {
            if (isNoteElement(element) || isStickyNotesElement(element)){
                formData.customData = element.customData;
                if (!formData.customData){
                    formData.customData = {generationData:{}}
                }
                if (!formData.customData.generationData){
                    formData.customData.generationData = {};
                }
                formData.customData.generationData.isFixedSize = true;
            }else if (isProjectLinkElement(element)){
                formData.customData = element.customData;
                formData.isFixedSize = true;
            }

            //这里还要更新有些元素原始的高度..
            if (element.customData?.generationData?.originHeight){
                const customData = {...element.customData};
                if (element.customData?.generationData?.originHeight){
                    //重新计算原始高度---- 按最初的宽高比
                    customData.generationData.originHeight = formData.width / customData.generationData.whRate;
                }
                formData.customData = customData;
            }

            let newElement: any = newElementWith(element, {
                ...formData
            });
            arrayNewElements.push(newElement)

            postMessage(EVENT_UPDATE_ELEMENT_BOUND,{element:newElement})

        }else{
            arrayNewElements.push(element);

            postMessage(EVENT_UPDATE_ELEMENT_BOUND,{element:element})
        }
    }
    return {
        elements:[...arrayNewElements],
        appState: {
            ...appState
        }
    };
}























